import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { storeReferralCode, trackReferralClick } from '../utils/referralTracking';

const ReferralRedirect = ({ sessionId }) => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const normalized = String(code || '').trim().toUpperCase();
    if (normalized) {
      storeReferralCode(normalized);
      trackReferralClick({
        code: normalized,
        sessionId,
        landingPath: `/r/${normalized}`,
      });
    }
    navigate(`/?ref=${encodeURIComponent(normalized)}`, { replace: true });
  }, [code, navigate, sessionId]);

  return null;
};

export default ReferralRedirect;
